import PropTypes from "prop-types";

/**
 * PropTypes for DropdownProvider context.
 *
 * @property {React.ReactNode} [children] - Wrapped dropdown components
 * @property {string} [placement] - Preferred menu placement
 * @property {React.ReactNode} [trigger] - Trigger element
 * @property {{current: any}} [parentRef] - Parent ref for positioning
 */
export const dropdownProviderPropTypes = {
  children: PropTypes.node,
  placement: PropTypes.string,
  trigger: PropTypes.node,
  parentRef: PropTypes.shape({ current: PropTypes.any }),
};

/**
 * PropTypes for ThemeProvider.
 *
 * @property {React.ReactNode} [children] - Application tree to receive theme context
 */
export const themeProviderPropTypes = {
  children: PropTypes.node,
};

/**
 * PropTypes for UserProvider.
 *
 * @property {React.ReactNode} [children] - Children receiving user context
 */
export const userProviderPropTypes = {
  children: PropTypes.node,
};
